import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export type WorkReportReviewStatus =
	| 'open'
	| 'accepted'
	| 'rejected'
	| 'skipped'

export interface GetWorkReportsParams {
	page: number
	size: number
	clientId?: string
	contactId?: string
	q?: string
	statuses?: string
	fromDayKey?: string
	toDayKey?: string
	reviewedOnly?: boolean
}

export interface WorkReportRecord {
	id: string
	clientId: string
	clientName: string
	contactId: string
	contactName: string
	mobile?: string
	shortSummary: string
	currentSummary?: string
	agentHandlingSummary?: string
	customerGoal?: string
	sentiment?: string
	urgency?: string
	isIssueCase?: boolean
	assignedAgentNames?: string[]
	summaryStatus?: string
	summaryReviewStatus: WorkReportReviewStatus | string
	summaryRejectionReason?: string
	summaryManualContext?: string
	summaryReviewedAt?: string | null
	summaryReviewedBy?: string
	summaryReviewedByName?: string
	generatedAt?: string | null
	updatedAt?: string | null
}

export interface GetWorkReportsResponse {
	totalCount: number
	totalPages: number
	currentPage: number
	records: WorkReportRecord[]
}

const getWorkReports = async (
	params: GetWorkReportsParams
): Promise<GetWorkReportsResponse> => {
	try {
		const { data } = await axios.get<GetWorkReportsResponse>(
			'v1/intelligence/management/work-reports',
			{ params }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getWorkReports
